@if (!status()) {
  <div class="vipps-section">
    <div class="vipps-section__buttons">
      @for (amount of amounts(); track $index) {
        <dv-button
          [isRound]="true"
          [isSelectedStateActive]="true"
          [selected]="selectedAmount() === amount"
          (click)="amountSelected(selectedAmount() === amount ? undefined : amount)"
        >
          {{ amount + ' NOK' | translate }}
        </dv-button>
      }

      <dv-button
        [isRound]="true"
        [isSelectedStateActive]="true"
        [selected]="selectedAmount() === 0"
        (click)="amountSelected(selectedAmount() === 0 ? undefined : 0)"
      >
        {{ 'Map.Vipps.AmountOther' | translate }}
      </dv-button>
    </div>
    @if (selectedAmount() === 0) {
      <div class="vipps-section__input">
        <dv-input-number
          [fieldMask]="{ allowNegativeNumbers: false, decimalDigits: 0, allowEmptyValue: true }"
          [(value)]="customAmount"
        ></dv-input-number>
      </div>
    }
    <div class="vipps-section__vipps">
      <vipps-mobilepay-button
        brand="vipps"
        [language]="translate.getCurrentLang()"
        rounded="true"
        stretched="true"
        verb="donate"
        branded="true"
        (click)="donateClicked()"
      >
      </vipps-mobilepay-button>
      <span class="dv-body-sm vipps-section__vipps--text">{{
        'Map.Vipps.DonationText' | translate
      }}</span>
      <span class="dv-body-sm vipps-section__vipps--text">{{
        'Map.Vipps.InfoDisclaimer' | translate
      }}</span>
    </div>
  </div>
} @else {
  <app-vipps-status [status]="status()" (cancel)="cancelDonation.emit()" />
}
